// Public references are strings; never derive them from orders.id or round
// their numeric suffix through Number. Historical leading zeros stay intact.
export const PUBLIC_ORDER_ID_MAX_NUMBER = 9007199254740991n
export const PUBLIC_ORDER_ID_MAX_LENGTH = 18

export function isPublicOrderId(value: unknown): value is string {
  if (typeof value !== 'string' || value !== value.trim() || !/^SG[0-9]{2,16}$/.test(value)) return false
  const number = BigInt(value.slice(2))
  return number >= 1n && number <= PUBLIC_ORDER_ID_MAX_NUMBER
}
